import moment from "moment";

export const formatDateEdit = (date) => {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
};

export function GetFormattedDate(dateString, formatString = "DD/MM/YYYY") {
  if (dateString) {
    return moment(dateString).format(formatString);
  }

  return "";
}
